/**
 * Reducer to manage user interaction (keystrokes, etc)
 */

import { ActionTypes as types } from '../constants'

const initialState = {
  hasEnteredOriginAmount: false,
  hasEnteredDestinationAmount: false,
  hasFocusedOnCountryInput: false,
  hasTypedInCountryInput: false,
  hasOpenedCountryDropdown: false,
  hasEnteredRecipient: false,
}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 */
export default function user(state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_ORIGIN_AMOUNT:
      return {
        ...state,
        hasEnteredOriginAmount: true,
      }
    case types.CHANGE_DESTINATION_AMOUNT:
      return {
        ...state,
        hasEnteredDestinationAmount: true,
      }
    case types.FOCUS_COUNTRY_INPUT:
      return {
        ...state,
        hasFocusedOnCountryInput: true,
      }
    case types.CHANGE_COUNTRY_INPUT:
      return {
        ...state,
        hasTypedInCountryInput: true,
      }
    case types.TRIGGER_COUNTRY_DROPDOWN:
      return {
        ...state,
        hasOpenedCountryDropdown: true,
      }
    case types.CHANGE_RECIPIENT:
      if (action.data.isInitialRecipientEntry === true) {
        return { ...state, hasEnteredRecipient: true }
      }
      return state

    default:
      return state
  }
}
